import React from 'react';
import styled, { keyframes } from 'styled-components';

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const pulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.03); }
`;

const HeroSection = styled.section`
  position: relative;
  background: linear-gradient(rgba(46, 125, 50, 0.7), rgba(27, 94, 32, 0.85)),
              url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 600"%3E%3Cdefs%3E%3ClinearGradient id="bg" x1="0%25" y1="0%25" x2="100%25" y2="100%25"%3E%3Cstop offset="0%25" style="stop-color:%234CAF50;stop-opacity:1" /%3E%3Cstop offset="100%25" style="stop-color:%232e7d32;stop-opacity:1" /%3E%3C/linearGradient%3E%3C/defs%3E%3Crect fill="url(%23bg)" width="1200" height="600"/%3E%3Cg opacity="0.3"%3E%3Ccircle cx="200" cy="150" r="80" fill="%23fff"/%3E%3Ccircle cx="800" cy="400" r="100" fill="%23fff"/%3E%3Ccircle cx="1000" cy="200" r="60" fill="%23fff"/%3E%3Cpath d="M 100 500 Q 300 450 500 500 T 900 500" stroke="%23fff" fill="none" stroke-width="3"/%3E%3C/g%3E%3C/svg%3E');
  background-size: cover;
  background-position: center;
  color: white;
  padding: 8rem 2rem;
  text-align: center;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 6rem 1rem;
  }
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 1;
`;

const HeroTitle = styled.h1`
  font-size: 3rem;
  margin-bottom: 1rem;
  animation: ${fadeInUp} 1s ease;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const HeroSubtitle = styled.p`
  font-size: 1.3rem;
  max-width: 800px;
  margin: 0 auto 2rem;
  animation: ${fadeInUp} 1s ease 0.2s both;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const CtaButton = styled.a`
  display: inline-block;
  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
  color: white;
  padding: 1rem 2.5rem;
  text-decoration: none;
  border-radius: 50px;
  font-weight: bold;
  transition: transform 0.3s, box-shadow 0.3s;
  animation: ${fadeInUp} 1s ease 0.4s both, ${pulse} 2s ease-in-out infinite;
  box-shadow: 0 5px 20px rgba(255, 152, 0, 0.3);

  &:hover {
    transform: translateY(-3px) scale(1.05);
    box-shadow: 0 10px 30px rgba(255, 152, 0, 0.5);
    animation: none;
  }
`;

const ScrollIndicator = styled.div`
  position: absolute;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  animation: bounce 2s infinite;
  font-size: 2rem;
  opacity: 0.7;
`;

const Hero: React.FC = () => {
  return (
    <HeroSection id="home">
      <HeroContent>
        <HeroTitle>Transforming Africa Through Integrated Development</HeroTitle>
        <HeroSubtitle>Breaking the cycle of poverty through multimodal interventions in health, education, and agriculture</HeroSubtitle>
        <CtaButton href="#contact">Join Our Mission</CtaButton>
      </HeroContent>
      <ScrollIndicator>↓</ScrollIndicator>
    </HeroSection>
  );
};

export default Hero;